import { useState } from "react";
import { Button, Dropdown, Statistic } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { useAuth } from "context/providers/auth";
import CreateUserPinModal from "./components/CreateUserPinModal";
import { useActivityProtect } from "components/ActivityProtect";
import dayjs from "dayjs";
import QrCodeModal from "./components/QrCodeModal";

const UserPanel = () => {
  const {
    state: {
      user: {
        full_name,
        session_expiration,
        session_expiration_time_in_seconds,
      },
    },
  } = useAuth();

  const [is_open, setOpenCreateModal] = useState(false);
  const [is_open_qr_modal, setOpenQrModal] = useState(false);
  const [expiration_time, setExpirationTime] = useState(session_expiration);
  const navigate = useNavigate();
  const { remainingTime } = useActivityProtect();

  const minutes = Math.floor(remainingTime / 60);
  const seconds = Math.floor(remainingTime % 60);

  const onFinish = () =>
    setExpirationTime(
      dayjs(expiration_time).add(session_expiration_time_in_seconds, "seconds")
    );
  return (
    <>
      <Dropdown
        menu={{
          items: [
            {
              className: "username",
              key: "1",
              label: full_name,
              disabled: true,
            },
            {
              key: "2",
              label: "Zmień PIN blokady ekr.",
              onClick: () => setOpenCreateModal(true),
            },
            {
              key: "3",
              label: "Próby dostępu",
              onClick: () => navigate("/alerts"),
            },
            {
              key: "4",
              label: "Pobierz kod QR",
              onClick: () => setOpenQrModal(true),
            },
            {
              key: "5",
              label: (
                <>
                  Czas do blokady ekranu: <br />
                  {`\n${minutes}:${
                seconds < 10 ? `0${seconds}` : seconds
              }`}
                </>
              ),
            },
            {
              key: "6",
              label: (
                <>
                  Czas do końca sesji:
                  <Statistic.Timer
                    type="countdown"
                    value={expiration_time}
                    onFinish={onFinish}
                  />
                </>
              ),
            },
          ],
        }}
        placement="bottomRight"
        arrow
      >
        <Button type="primary" htmlType="button" icon={<UserOutlined />} />
      </Dropdown>
      <CreateUserPinModal
        is_open={is_open}
        handleClose={() => setOpenCreateModal(false)}
      />
      <QrCodeModal
        is_open={is_open_qr_modal}
        handleClose={() => setOpenQrModal(false)}
      />
    </>
  );
};

export default UserPanel;
